var _clipPath;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAltEthanol(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "105.82mm",
    height: "122mm",
    viewBox: "0 0 105.82 122",
    xmlSpace: "preserve",
    id: "svg100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs104"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient7144"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffadad",
      stopOpacity: 1
    },
    offset: 0,
    id: "stop7142"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient7130"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffadad",
      stopOpacity: 1
    },
    offset: 0,
    id: "stop7128"
  })), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "Clip0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 L161 0 L161 101 L0 101 L0 0 Z",
    transform: "translate(0, 0)",
    id: "path10494"
  })))), /*#__PURE__*/React.createElement("rect", {
    style: {
      mixBlendMode: "multiply",
      fill: "#ff8e8e",
      fillOpacity: 0,
      fillRule: "evenodd",
      stroke: "#840000",
      strokeWidth: 1.464,
      strokeLinecap: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.450777
    },
    id: "rect262",
    width: 103.02634,
    height: 118.93182,
    x: 1.3825192,
    y: 1.685971,
    ry: 7.1569595
  }), /*#__PURE__*/React.createElement("g", {
    id: "g21847",
    style: {
      mixBlendMode: "soft-light",
      stroke: "#ffe854",
      strokeWidth: 1.506,
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 0.3333334,
      paintOrder: "stroke markers fill"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe1",
    clipPath: "url(#Clip0)",
    transform: "matrix(0.35277778,0,0,0.35277778,24.471611,64.755933)",
    style: {
      stroke: "#ffe854",
      strokeWidth: 4.26898,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 0.3333334,
      paintOrder: "stroke markers fill"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      fillRule: "evenodd",
      stroke: "#ffe854",
      strokeWidth: 4.26898,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 0.3333334,
      paintOrder: "stroke markers fill"
    },
    d: "m 11.2266,9.5274 v 7.9648 h 2.2343 V 0 H 11.2266 V 7.5586 H 2.23047 V 0 H 0 V 17.4922 H 2.23047 V 9.5274 Z",
    transform: "translate(4.29199,41.6074)",
    id: "path10499"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      fillRule: "evenodd",
      stroke: "#ffe854",
      strokeWidth: 4.26898,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 0.3333334,
      paintOrder: "stroke markers fill"
    },
    d: "M 14.7304,5.7109 C 14.0351,1.875 11.8281,0 7.9882,0 5.6367,0 3.7421,0.746 2.4453,2.1835 0.8632,3.914 0,6.4101 0,9.2382 c 0,2.8789 0.8867,5.3516 2.5195,7.0547 1.3672,1.3906 3.0937,2.0391 5.375,2.0391 4.2695,0 6.668,-2.3008 7.1953,-6.9336 H 12.789 c -0.1914,1.1992 -0.4336,2.0156 -0.793,2.7109 -0.7187,1.4414 -2.207,2.2578 -4.0781,2.2578 -3.4804,0 -5.6875,-2.7851 -5.6875,-7.1523 0,-4.4844 2.086,-7.2461 5.4961,-7.2461 1.4141,0 2.7344,0.4102 3.4531,1.1055 0.6485,0.5976 1.0079,1.3203 1.2735,2.6367 z",
    transform: "translate(42.252,41.4688)",
    id: "path10501"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      fillRule: "nonzero",
      stroke: "#ffe854",
      strokeWidth: 4.26898,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 0.3333334,
      paintOrder: "stroke markers fill"
    },
    d: "M 20.0996,0 V 1.6992 H 0 V 0 Z",
    transform: "translate(19.9004,49.6504)",
    id: "path10503"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      fillRule: "evenodd",
      stroke: "#ffe854",
      strokeWidth: 4.26898,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 0.3333334,
      paintOrder: "stroke markers fill"
    },
    d: "M 14.7305,5.7109 C 14.0352,1.875 11.8282,0 7.9883,0 5.6368,0 3.7422,0.746 2.4454,2.1835 0.8633,3.914 0,6.4101 0,9.2382 c 0,2.8789 0.8868,5.3516 2.5196,7.0547 1.3672,1.3906 3.0937,2.0391 5.375,2.0391 4.2695,0 6.6679,-2.3008 7.1953,-6.9336 h -2.3008 c -0.1914,1.1992 -0.4336,2.0156 -0.793,2.7109 -0.7187,1.4414 -2.207,2.2578 -4.0781,2.2578 -3.4805,0 -5.6875,-2.7851 -5.6875,-7.1523 0,-4.4844 2.086,-7.2461 5.4961,-7.2461 1.4141,0 2.7344,0.4102 3.4531,1.1055 0.6485,0.5976 1.0078,1.3203 1.2735,2.6367 z",
    transform: "translate(81.9023,41.4688)",
    id: "path10505"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      fillRule: "nonzero",
      stroke: "#ffe854",
      strokeWidth: 4.26898,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 0.3333334,
      paintOrder: "stroke markers fill"
    },
    d: "M 20,0 V 1.6992 H 0 V 0 Z",
    transform: "translate(59.7002,49.6504)",
    id: "path10507"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      fillRule: "evenodd",
      stroke: "#ffe854",
      strokeWidth: 4.26898,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 0.3333334,
      paintOrder: "stroke markers fill"
    },
    d: "m 11.2265,9.5273 v 7.9649 h 2.2344 V 0 H 11.2265 V 7.5586 H 2.2305 V 0 H 0 V 17.4922 H 2.2305 V 9.5273 Z",
    transform: "translate(43.9424,1.9082)",
    id: "path10509"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      fillRule: "nonzero",
      stroke: "#ffe854",
      strokeWidth: 4.26898,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 0.3333334,
      paintOrder: "stroke markers fill"
    },
    d: "M 0,0 H 1.7002 V 17.8496 H 0 Z",
    transform: "translate(47.8496,21.7002)",
    id: "path10511"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      fillRule: "evenodd",
      stroke: "#ffe854",
      strokeWidth: 4.26898,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 0.3333334,
      paintOrder: "stroke markers fill"
    },
    d: "m 11.2265,9.5274 v 7.9648 h 2.2344 V 0 H 11.2265 V 7.5586 H 2.2305 V 0 H 0 V 17.4922 H 2.2305 V 9.5274 Z",
    transform: "translate(43.9424,81.3076)",
    id: "path10513"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      fillRule: "nonzero",
      stroke: "#ffe854",
      strokeWidth: 4.26898,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 0.3333334,
      paintOrder: "stroke markers fill"
    },
    d: "M 1.7002,17.8496 H 0 V 0 h 1.7002 z",
    transform: "translate(47.8496,61.5)",
    id: "path10515"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      fillRule: "evenodd",
      stroke: "#ffe854",
      strokeWidth: 4.26898,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 0.3333334,
      paintOrder: "stroke markers fill"
    },
    d: "m 11.2265,9.5273 v 7.9649 h 2.2344 V 0 H 11.2265 V 7.5586 H 2.2304 V 0 H 0 V 17.4922 H 2.2304 V 9.5273 Z",
    transform: "translate(83.6426,1.9082)",
    id: "path10517"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      fillRule: "nonzero",
      stroke: "#ffe854",
      strokeWidth: 4.26898,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 0.3333334,
      paintOrder: "stroke markers fill"
    },
    d: "M 0,0 H 1.7002 V 17.8496 H 0 Z",
    transform: "translate(87.5,21.7002)",
    id: "path10519"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      fillRule: "evenodd",
      stroke: "#ffe854",
      strokeWidth: 4.26898,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 0.3333334,
      paintOrder: "stroke markers fill"
    },
    d: "m 11.2265,9.5274 v 7.9648 h 2.2344 V 0 H 11.2265 V 7.5586 H 2.2304 V 0 H 0 V 17.4922 H 2.2304 V 9.5274 Z",
    transform: "translate(83.6426,81.3076)",
    id: "path10521"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      fillRule: "nonzero",
      stroke: "#ffe854",
      strokeWidth: 4.26898,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 0.3333334,
      paintOrder: "stroke markers fill"
    },
    d: "M 1.7002,17.8496 H 0 V 0 h 1.7002 z",
    transform: "translate(87.5,61.5)",
    id: "path10523"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      fillRule: "evenodd",
      stroke: "#ffe854",
      strokeWidth: 4.26898,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 0.3333334,
      paintOrder: "stroke markers fill"
    },
    d: "M 8.422,0 C 3.41,0 0,3.6953 0,9.1679 c 0,5.4922 3.383,9.1641 8.449,9.1641 2.133,0 4.004,-0.6485 5.422,-1.8477 1.894,-1.6054 3.023,-4.3164 3.023,-7.1718 C 16.894,3.6718 13.558,0 8.422,0 Z m 0,1.9687 c 3.793,0 6.238,2.8555 6.238,7.293 0,4.2265 -2.52,7.1054 -6.211,7.1054 -3.746,0 -6.215,-2.8789 -6.215,-7.1992 0,-4.3203 2.469,-7.1992 6.188,-7.1992 z",
    transform: "translate(120.76,41.4688)",
    id: "path10525"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      fillRule: "nonzero",
      stroke: "#ffe854",
      strokeWidth: 4.26898,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 0.3333334,
      paintOrder: "stroke markers fill"
    },
    d: "M 19.3496,0 V 1.6992 H 0 V 0 Z",
    transform: "translate(99.4004,49.6504)",
    id: "path10527"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      fillRule: "evenodd",
      stroke: "#ffe854",
      strokeWidth: 4.26898,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 0.3333334,
      paintOrder: "stroke markers fill"
    },
    d: "m 11.226,9.52739 v 7.96481 h 2.235 V 0 H 11.226 V 7.55859 H 2.23 V 0 H 0 V 17.4922 H 2.23 V 9.52739 Z",
    transform: "translate(143.143,7.25781)",
    id: "path10529"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      fillRule: "nonzero",
      stroke: "#ffe854",
      strokeWidth: 4.26898,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 0.3333334,
      paintOrder: "stroke markers fill"
    },
    d: "M 8,0 9.5,0.8496 1.5,14.7002 0,13.8496 Z",
    transform: "translate(133.1,26.2002)",
    id: "path10531"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipRule: "evenodd",
      strokeMiterlimit: 10,
      strokeWidth: 41.75482481,
      strokeDasharray: "none",
      paintOrder: "markers stroke fill",
      stroke: "#ffe854",
      strokeOpacity: 0.3333334
    },
    id: "g11333",
    transform: "matrix(0.08875621,0,0,0.08875621,8.6338396,16.826195)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g11315",
    style: {
      strokeWidth: 41.75482481,
      strokeDasharray: "none",
      paintOrder: "markers stroke fill",
      stroke: "#ffe854",
      strokeOpacity: 0.3333334
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 392.36,52.27 v 18.6 L 57.5,264.73 48.69,250.04 392.36,52.27",
    fill: "#000000",
    id: "path11307",
    style: {
      strokeWidth: 41.75482481,
      strokeDasharray: "none",
      paintOrder: "markers stroke fill",
      stroke: "#ffe854",
      strokeOpacity: 0.3333334
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 647.06,260.64 c 0,-29.09 7.8,-51.87 23.42,-68.33 15.61,-16.46 35.76,-24.69 60.45,-24.69 16.17,0 30.74,3.87 43.72,11.6 12.99,7.73 22.88,18.51 29.69,32.34 6.81,13.83 10.22,29.51 10.22,47.05 0,17.77 -3.59,33.68 -10.76,47.7 -7.16,14.03 -17.32,24.65 -30.46,31.86 -13.14,7.22 -27.32,10.82 -42.53,10.82 -16.49,0 -31.22,-3.98 -44.21,-11.95 -12.98,-7.97 -22.81,-18.85 -29.51,-32.64 -6.69,-13.79 -10.03,-28.38 -10.03,-43.76 z m 23.87,0.36 c 0,21.11 5.68,37.75 17.03,49.9 11.36,12.15 25.6,18.22 42.73,18.22 17.45,0 31.81,-6.13 43.08,-18.4 11.27,-12.27 16.91,-29.68 16.91,-52.23 0,-14.26 -2.41,-26.71 -7.23,-37.35 -4.82,-10.63 -11.87,-18.88 -21.15,-24.73 -9.28,-5.86 -19.7,-8.79 -31.25,-8.79 -16.42,0 -30.54,5.64 -42.37,16.91 -11.83,11.28 -17.75,30.1 -17.75,56.47 z m 0,0",
    fill: "#000000",
    id: "path11309",
    style: {
      strokeWidth: 41.75482481,
      strokeDasharray: "none",
      paintOrder: "markers stroke fill",
      stroke: "#ffe854",
      strokeOpacity: 0.3333334
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 845.86,345.99 V 170.75 h 23.13 v 72 h 91 v -72 h 23.12 v 175.24 h -23.12 v -82.62 h -91 v 82.62 z m 0,0",
    fill: "#000000",
    id: "path11311",
    style: {
      strokeWidth: 41.75482481,
      strokeDasharray: "none",
      paintOrder: "markers stroke fill",
      stroke: "#ffe854",
      strokeOpacity: 0.3333334
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 638.12,194.24 629.31,208.92 392.36,70.87 v -18.6 l 245.76,141.97",
    fill: "#000000",
    id: "path11313",
    style: {
      strokeWidth: 41.75482481,
      strokeDasharray: "none",
      paintOrder: "markers stroke fill",
      stroke: "#ffe854",
      strokeOpacity: 0.3333334
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAltEthanol);
export default __webpack_public_path__ + "static/media/altEthanol.09dd06b6261e8fb11a2bffed33d2a023.svg";
export { ForwardRef as ReactComponent };